<template>
	<div class="px-5">
		<app-table
			class="is-not-selectable mt-5"
			name="action-list"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
				>
					{{ props.row.name }}
				</td>
				<td>{{ props.row.code }}</td>
				<td>{{ props.row.codeWeb }}</td>
				<td>{{ props.row.numFragment }}</td>
				<td>{{ props.row.position }}</td>
				<td>{{ props.row.stringLanguages }}</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar"
						@click-icon="openEdit(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	const headers = {
		Accept: process.env.ACCEPT_SERVICE_V2,
	};
	this.loading = true;
	this.$http
		.delete(`action-bar/${this.modalConfirmation.selectedRow.id}`, { headers })
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
		})
		.catch((err) => {
			if (err.status === 405) {
				if (err.data.message === 'RESOURCE_HAS_ASSOCIATED_DATA') {
					this.showError('La acción no pudo ser eliminada por tener data asociada.');
				}
			}
		})
		.finally(() => {
			this.loading = false;
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		});
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openEdit(row) {
	this.$emit('open-edit', row);
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'action-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		confirm,
		onSearch,
		openEdit,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/actions/action-list.vue